<script lang="ts" module>
  import ImpactTpi from '@/ui/components/assistant/Performance/AICard/cmps/ImpactTPI.svelte';

  import CtaButton from '../buttons/CTAButton.svelte';
  import HelpButton from '../buttons/HelpButton.svelte';

  export interface TextViewProps {
    variant: 'TextView' | 'TextInput';
    text?: string;
    tpi?: number;
    disabled?: boolean;
    onTranslateClick?: (text: string) => void;
    infoText?: string;
    helpTopicName?: string;
    loading?: boolean;
    scrollable?: boolean;
  }
</script>

<script lang="ts">
  let {
    disabled: disabledProp = false,
    loading: loadingProp = false,
    ...props
  }: TextViewProps = $props();

  let btnLabel: string = $derived(props.variant === 'TextView' ? 'Übersetzen' : 'Erstellen');

  let textContent: string = $state(props.text ?? '');
  $effect(() => {
    if (props.text) {
      textContent = props.text;
    }
  });
</script>

<div class="grid h-full grid-rows-[auto_1fr_auto] gap-1 rounded-lg bg-white p-4 shadow-card">
  <div class="grid gap-3">
    <div class="flex">
      <div class="flex-none">
        <ImpactTpi tpi={props.tpi ?? 0} hideSign hidePercentage></ImpactTpi>
      </div>
      <div class="flex-1 text-right">
        {#if props.helpTopicName}
          <HelpButton label="Hilfe" topic={props.helpTopicName} section="s" content="c"
          ></HelpButton>
        {/if}
      </div>
    </div>
    <hr class="border-t-c-divider" />
  </div>

  <div class="p-10" class:overflow-y-auto={props.scrollable}>
    {#if props.variant === 'TextView'}
      <!-- {#if !disabledProp} -->
      <div class="whitespace-pre-wrap font-editor text-sm">
        {props.text}
      </div>
      <!-- {/if} -->
    {:else if props.variant === 'TextInput'}
      <textarea
        contenteditable
        bind:value={textContent}
        id="text"
        name="text"
        class="h-full w-full resize-none focus:outline-none"
        placeholder="Bitte schreiben Sie hier Stichpunkte ihrers Anschreibens rein."
      ></textarea>
    {/if}
  </div>

  <div class="grid gap-3">
    <hr class="border-t-c-divider" />
    <div class="flex">
      <div class="flex flex-1 items-center font-sans text-xs font-normal text-c-light">
        {props.infoText}
      </div>
      <div class="flex flex-1 justify-end">
        <CtaButton
          disabled={disabledProp && textContent.length === 0}
          variant="cta"
          loading={loadingProp}
          onclick={() => {
            props.onTranslateClick?.(textContent);
          }}>{btnLabel}</CtaButton
        >
      </div>
    </div>
  </div>
</div>
